<section>
    <img width="100%" src="/assets/images/micrositio/homepage/HOME_028.jpg">
    <br>
    <img width="100%" src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA2.jpg">
</section>
<div class="container">
    <div class="row marg">
        <div class="col-sm-12">
            <div class="row">
                <div class="col-sm-7">
                    <p class="font-20 text-grey">
                        RECORRIDOS
                    </p>
                    <p class="fontMS700 colorPrincipal font-40" style="line-height: 2.5rem;">
                        TRANSICIONES Y<br>
                        TRANSFORMACIONES<br>
                        SOCIALES<br>
                        <br>
                    </p>
                </div>
                <div class="col-sm-5">
                    <div id="sharePic">
                        <a (click)="test.toggle()" mdbWavesEffect>
                            <img width="200px" src="/assets/images/general/MP_BOTON_COMPARTIR.jpg">
                        </a>
                        <div mdbCollapse #test="bs-collapse">
                            <div class="divShared">
                                &nbsp;
                                &nbsp;
                                <a target="_blank"
                                    href="http://www.facebook.com/sharer.php?u=https://memoriaperu.bnp.gob.pe%2F%23%2Fhome/generica4">
                                    <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_FB.png">
                                </a>&nbsp;
                                <a target="_blank"
                                    href="https://api.whatsapp.com/send?text=https://memoriaperu.bnp.gob.pe%2F%23%2Fhome/generica4">
                                    <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_INST.png">
                                </a>&nbsp;
                                <a target="_blank"
                                    href="https://twitter.com/intent/tweet?text=MemoriaPeru&url=https://memoriaperu.bnp.gob.pe%2F%23%2Fhome/generica4">
                                    <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_TW.png">
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-7">
                    <p class="font-20">
                        <br>
                        <span class="fontMS500 font-22">
                            RECORRIDO POR LA CORRESPONDENCIA, FOTOGRAFÍA,
                            DISCURSOS, PERIÓDICOS, FOLLETOS, LIBROS Y DIVERSOS DOCUMENTOS A TRAVÉS DE LOS CUALES PODEMOS
                            REFLEXIONAR SOBRE LA RELACIÓN ENTRE EL ESTADO Y LA SOCIEDAD Y SU DEVENIR EN EL PRESENTE.
                            <br><br>
                        </span>
                        El proceso de Independencia, la Guerra del Pacífico y el conflicto armado interno son algunos
                        ejemplos de los sucesos que han dejado profundas huellas en nuestra sociedad. Desde estos
                        momentos cruciales hasta las luchas sociales y procesos económicos que han transformado el país,
                        en este recorrido se invita a reflexionar sobre el rol del Estado, los gobiernos y la ciudadanía
                        en algunos de los hitos de la historia peruana.
                        <br><br>
                    </p>
                </div>
                <div class="col-sm-1">
                </div>
                <div class="col-sm-4">
                    <p class="fontMS500 font-22">
                        <br> OTROS RECORRIDOS <br>
                        <span class="font-20 text-grey">
                            <u>
                                <a style="color: inherit;" (click)="creadores()">Creadores</a><br>

                                <a style="color: inherit;" (click)="miradasArta()">Miradas desde el Arte</a><br>

                                <a style="color: inherit;" (click)="comunidadesImg()">Comunidades Imaginadas</a><br>
                            </u>
                        </span>
                    </p>
                </div>
            </div>
            <p class="fontMS500 font-30">
                TEMAS
            </p>
            <div class="row">
                <div class="col-sm-8">
                    <img width="100%" src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA2.jpg">
                    <div class="row">
                        <div class="col-sm-4">
                            <a (click)="DerechosMujer()">
                                <img width="100%" src="/assets/images/micrositio/homepage/HOME_028e.jpg">
                            </a>
                        </div>
                        <div class="col-sm-8">
                            <a (click)="DerechosMujer()">
                                <p class="fontMS700 font-24">
                                    LOS DERECHOS DE LA MUJER PERUANA (1910-1956)
                                </p>
                            </a>
                        </div>
                    </div>
                    <img width="100%" src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA2.jpg">
                    <div class="row">
                        <div class="col-sm-4">
                            <a (click)="Federalismo()">
                                <img width="100%" src="/assets/images/micrositio/homepage/HOME_028a.jpg">
                            </a>
                        </div>
                        <div class="col-sm-8">
                            <a (click)="Federalismo()">
                                <p class="fontMS700 font-24">
                                    FEDERALISMO Y RECONSTRUCCIÓN NACIONAL (1895-1899)
                                </p>
                            </a>
                        </div>
                    </div>
                    <img width="100%" src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA2.jpg">
                    <div class="row">
                        <div class="col-sm-4">
                            <a (click)="AlbumRepublica()">
                                <img width="100%" src="/assets/images/micrositio/homepage/HOME_024d.jpg">
                            </a>
                        </div>
                        <div class="col-sm-8">
                            <a (click)="AlbumRepublica()">
                                <p class="fontMS700 font-24">
                                    ÁLBUM REPÚBLICA PERUANA 1900<br>
                                    ALBORES Y ANHELOS
                                    DE MODERNIZACIÓN
                                </p>
                            </a>
                        </div>
                    </div>
                    <img width="100%" src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA2.jpg">
                    <div class="row">
                        <div class="col-sm-4">
                            <a (click)="Prensa()">
                                <img width="100%" src="/assets/images/micrositio/homepage/HOME_051a.png">
                            </a>
                        </div>
                        <div class="col-sm-8">
                            <a (click)="Prensa()">
                                <p class="fontMS700 font-24">
                                    LA PRENSA<br>
                                    EN LA INDEPENDENCIA
                                </p>
                            </a>
                        </div>
                    </div>
                    <img width="100%" src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA2.jpg">
                    <div class="row">
                        <div class="col-sm-4">
                            <a (click)="Retrato()">
                                <img width="100%" src="/assets/images/micrositio/homepage/HOME_050a.png">
                            </a>
                        </div>
                        <div class="col-sm-8">
                            <a (click)="Retrato()">
                                <p class="fontMS700 font-24">
                                    RETRATOS<br>
                                    FAMILIARES
                                </p>
                            </a>
                        </div>
                    </div>
                    <img width="100%" src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA2.jpg">
                    <div class="row">
                        <div class="col-sm-4">
                            <a (click)="Sesquicentenario()">
                                <img width="100%" src="/assets/images/micrositio/homepage/HOME_057a.png">
                            </a>
                        </div>
                        <div class="col-sm-8">
                            <a (click)="Sesquicentenario()">
                                <p class="fontMS700 font-24">
                                    SESQUICENTENARIO<br>
                                    DE LA INDEPENDENCIA DEL PERÚ
                                </p>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="col-sm-4">
                </div>
            </div>
        </div>
    </div>
</div>